//@flow
import React from 'react';
import {useHistory} from 'react-router-dom';
import {makeStyles, Typography, IconButton, Divider} from '@material-ui/core';
import AlertDueDateTier from '../../tiers/components/AlertDueDateTier/AlertDueDateTier';
import {
  ArrowBack,
  InsertDriveFile,
  Description,
  GetApp,
  Cached,
  Error,
} from '@material-ui/icons';
import {colors} from '../../../assets/styles/colors';
import CustomButton from '../../../elements/CustomButton/CustomButton';
import {useProductCatalogue} from '../utils';
import {formatDateTime} from '../../../utils/date';
import InlineLoader from '../../../elements/LoadingSpinner/InlineLoader';
import {getImageUrl} from '../../../utils/image_provider';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    background: '#F8F9FB',
    padding: '0 1rem',
    gap: '1rem',
    marginBottom: '1rem',
  },
  headerWrapper: {
    maxWidth: 1300,

    background: '#f8f9fb',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '16px',
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'black',
  },
  backButton: {
    background: 'white',
    padding: '4px',
    margin: '0 16px 0 0',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
  subtitle: {
    fontSize: '14px',
    color: '#4D4D4D',
  },
  divider: {
    margin: '1rem 0',
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'flex-start',
    gap: '.5rem',
    position: 'relative',
    padding: '1rem',
    background: 'white',
    boxShadow: '0px 0px 1px rgba(40, 41, 61, 0.08)',
    borderRadius: '.5rem',
  },
  emptyArea: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    aspectRatio: '3/2',
    background: colors.grey100,
    borderRadius: '.5rem',
    border: `1px solid ${colors.grey300}`,
    maxHeight: '200px',
    gap: '1rem',
    flexDirection: 'column',
    color: colors.grey700,
  },
  waitingArea: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    aspectRatio: '3/2',
    background: colors.grey100,
    borderRadius: '.5rem',
    border: `1px solid ${colors.grey300}`,
    maxHeight: '200px',
    gap: '.25rem',
    flexDirection: 'column',
    color: colors.primary,
  },
  errorArea: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    aspectRatio: '3/2',
    background: colors.grey100,
    borderRadius: '.5rem',
    border: `1px solid ${colors.grey300}`,
    maxHeight: '200px',
    gap: '1rem',
    flexDirection: 'column',
    color: colors.danger,
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  caption: {
    fontSize: '.75rem',
    color: colors.grey700,
    textAlign: 'center',
  },
  loader: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1,
    background: 'rgba(255, 255, 255, .8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  resultInformation: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    width: '100%',
    background: colors.grey100,
    borderRadius: '.5rem',
    padding: '1rem',
    border: `1px solid ${colors.grey300}`,
    flexWrap: 'wrap',

    [theme.breakpoints.up('sm')]: {
      padding: '.5rem',
      flexWrap: 'nowrap',
    },
  },
  preview: {
    width: '3rem',
    height: '3rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '.5rem',
    background: colors.grey400,
  },
  name: {
    fontSize: '.875rem',
    fontWeight: 600,
  },
  description: {
    fontSize: '.875rem',
    color: colors.grey700,
  },
  information: {
    flexGrow: 1,
  },
  refreshSubtitle: {
    fontSize: '.875rem',
    fontWeight: 600,
  },
  refreshCaption: {
    fontSize: '.875rem',
    color: colors.grey700,
  },
  refreshContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
    justifyContent: 'space-between',

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  subtitleError: {
    fontSize: '.875rem',
    color: colors.danger,
  },
}));

export default function ProductCatalogue() {
  const classes = useStyles();
  const history = useHistory();

  const {generateCatalogue, loading, productCatalogue} = useProductCatalogue();

  const handleClickDownloadClick = () => {
    if (!productCatalogue) return;
    const url = getImageUrl(productCatalogue.fileId);
    window.open(url, '_blank');
  };

  return (
    <div className={classes.root}>
      <AlertDueDateTier />
      <div className={classes.headerWrapper}>
        <Typography className={classes.title}>
          <IconButton
            className={classes.backButton}
            onClick={() => history.goBack()}
          >
            <ArrowBack />
          </IconButton>
          Catálogo en PDF
        </Typography>
        <Typography className={classes.subtitle}>
          Esta funcionalidad te permitirá generar un catálogo profesional
          directamente desde nuestra nueva herramienta
        </Typography>
      </div>
      {/* 
      <div className={classes.emptyArea}>
        <span className={classes.subtitle}>
          Te redirigiremos a una nueva página donde podrás personalizar y
          descargar el catálogo.
        </span>
        <CustomButton
          variant="contained"
          color="primary"
          component={Link}
          to="/product-catalog-pdf"
          target="_blank"
        >
          Ir a Generar Catálogo
        </CustomButton>
      </div> */}

      <section className={classes.content}>
        {loading && (
          <div className={classes.loader}>
            <InlineLoader loading size={40} />
          </div>
        )}
        <Typography variant="subtitle1">Último catálogo</Typography>
        {productCatalogue && productCatalogue.state === 'BUILT' && (
          <>
            <div className={classes.resultInformation}>
              <span className={classes.preview}>
                <Description />
              </span>

              <div className={classes.information}>
                <Typography className={classes.name}>
                  Plantilla Productos
                </Typography>

                <Typography className={classes.description}>
                  Fecha: {formatDateTime(new Date(productCatalogue.updatedAt))}
                </Typography>
              </div>

              <CustomButton
                endIcon={<GetApp />}
                onClick={handleClickDownloadClick}
              >
                Descargar
              </CustomButton>
            </div>
            <Divider className={classes.divider} />
            <div className={classes.refreshContainer}>
              <Typography className={classes.refreshSubtitle}>
                Refrescar descarga
              </Typography>
              <div className={classes.refreshContent}>
                <Typography className={classes.refreshCaption}>
                  Actualiza tu catálogo PDF si realizaste algún actualización en
                  tu tienda. Desde creación de productos nuevos hasta cambio de
                  precios.
                </Typography>

                <CustomButton
                  color="default"
                  variant="outlined"
                  startIcon={<Cached />}
                  onClick={generateCatalogue}
                >
                  Refrescar Catálogo
                </CustomButton>
              </div>
            </div>
          </>
        )}
        {!productCatalogue && (
          <div className={classes.emptyArea}>
            <span className={classes.icon}>
              <InsertDriveFile />
            </span>
            <span className={classes.subtitle}>
              Aun no tiene catálogos descargados
            </span>
            <CustomButton
              variant="contained"
              color="primary"
              onClick={generateCatalogue}
            >
              Generar Catálogo PDF
            </CustomButton>
          </div>
        )}

        {productCatalogue && productCatalogue.state === 'FAILED' && (
          <div className={classes.errorArea}>
            <span className={classes.icon}>
              <Error />
            </span>
            <span className={classes.subtitleError}>
              Ocurrió un error al generar el catálogo
            </span>
            <CustomButton
              variant="outlined"
              color="primary"
              onClick={generateCatalogue}
              startIcon={<Cached />}
            >
              Volver a intentar
            </CustomButton>
          </div>
        )}

        {productCatalogue && productCatalogue.state === 'PENDING' && (
          <div className={classes.waitingArea}>
            <strong className={classes.label}>Procesando...</strong>
            <strong className={classes.caption}>
              Puede tardar entre 1 minuto a 2 horas.
            </strong>
            <span className={classes.caption}>
              Puedes salir de esta página sin problemas, mientras tu documento
              sigue procesando
            </span>
          </div>
        )}
      </section>
    </div>
  );
}
